var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"docHeader",staticClass:"grid-document-header"},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"document-logo"},[_c('div',{staticClass:"document-author-logo"},[_c('img',{attrs:{"src":require("../../assets/qps.png"),"alt":"SSP Elektro GmbH"}})])])
}]

export { render, staticRenderFns }